export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
